// assets
import { IconChartBar } from '@tabler/icons-react';

// constant
const icons = { IconChartBar };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'active',
      title: 'Active',
      type: 'item',
      url: '/dashboard/active',
      icon: icons.IconChartBar,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
